<script>
import {alterarRegraMeioDia} from '../../../../../domain/grv/services'

export default {
  name: 'BtnAlterarRegraMeioDia',
  props: {
    grvId: {
      type: [String, Number],
      required: true
    },
    isRegraMeioDiaAtivada: {
      type: Boolean,
      required: true
    },
    ocultarAposMeioDia: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    isPosMeioDia () {
      const horaAtual = (new Date()).getHours()
      return this.ocultarAposMeioDia && (horaAtual >= 12)
    }
  },
  methods: {
    alterarRegraMeioDia () {
      const desativarRegraMeioDia = this.isRegraMeioDiaAtivada
      const confirm = window.confirm(`${desativarRegraMeioDia ? 'Desativar' : 'Ativar'} regra de meio-dia para esta GRV?`)
      if (!confirm) return
      alterarRegraMeioDia(this.grvId, desativarRegraMeioDia)
        .then(response => {
          this.$emit('alterado')
        })
    }
  }
}
</script>

<template>
  <button
    class="btn btn-xs font-bold"
    :class="{'btn-danger': isRegraMeioDiaAtivada, 'btn-dark': !isRegraMeioDiaAtivada}"
    @click="alterarRegraMeioDia"
    v-if="!isPosMeioDia"
  >
    {{isRegraMeioDiaAtivada ? 'Desativar' : 'Ativar'}} regra meio-dia
  </button>
</template>



// WEBPACK FOOTER //
// BtnAlterarRegraMeioDia.vue?6d883618